import Box from '@mui/material/Box';
import { RoundStepper, RoundStepperProps } from '../RoundStepper';
import { useMobile } from 'src/hooks/useMobile';
import { Bracket, BracketProps } from './Bracket';
import { BracketLoser } from './BracketLoser';
import { useMemo } from 'react';
import { BracketLoserTitle } from './BracketLoserTitle';
import { BracketPanelRendered } from './BracketPanelRendered';
import { useBracket } from './BracketProvider';

export type BracketBoardProps = Omit<BracketProps, 'Match'> &
  Omit<RoundStepperProps, 'isMobile' | 'roundsCount'> & {
    activeRound?: number;
    activeRoundProgress?: number;
    isLoserBracket?: boolean;
  };

export function BracketBoard({
  rounds,
  roundPrizes,
  activeRound,
  activeRoundProgress,
  isLoserBracket,
}: BracketBoardProps) {
  const isMobile = useMobile();
  const { sponsors } = useBracket();

  const sponsorOffset = useMemo(() => {
    switch (rounds.length) {
      case 1:
        return 28;
      case 2:
        return isLoserBracket ? 60 : 68;
      case 3:
        return 70;
      case 4:
        return isLoserBracket ? 38 : 12;
      case 6:
        return 34;
      default:
        return 0;
    }
  }, [rounds.length, isLoserBracket]);

  return (
    <Box>
      {isLoserBracket && <BracketLoserTitle />}
      <Box
        sx={{
          display: 'flex',
          flexDirection: isLoserBracket ? 'column-reverse' : 'column',
          alignItems: isMobile ? 'flex-start' : 'center',
          m: 4,
          pb: 4,
          position: 'relative',
          overflowX: 'auto',
        }}
      >
        {!!sponsors?.length && (
          <BracketPanelRendered isLoserBracket={isLoserBracket} />
        )}
        <Box
          sx={{
            width:
              (isMobile ? 208 : 284) *
              (isLoserBracket && !isMobile
                ? Math.ceil(rounds.length / 2) + 1
                : rounds.length),
            mt: 0,
          }}
        >
          <RoundStepper
            {...{
              roundsCount: rounds.length,
              roundPrizes,
              activeRound,
              activeRoundProgress,
              isLoserBracket,
            }}
          />
        </Box>

        <Box
          sx={{
            mt: isMobile ? 0 : sponsorOffset,
            py: isLoserBracket ? 6 : 0,
          }}
        >
          {isLoserBracket ? (
            <BracketLoser rounds={rounds} />
          ) : (
            <Bracket rounds={rounds} />
          )}
        </Box>
      </Box>
    </Box>
  );
}
